import posthog from 'posthog-js';
import React from 'react';
import ReactDOM from 'react-dom';
import { AuthProvider } from 'react-oidc-context';

import App from './App';
import { oidcConfig } from './config/oidc';

if (process.env.REACT_APP_POSTHOG_KEY) {
  posthog.init(process.env.REACT_APP_POSTHOG_KEY, {
    api_host: 'https://eu.i.posthog.com'
  });
} else {
  // eslint-disable-next-line no-console
  console.warn('POSTHOG KEY: The posthog key is missing!');
}

ReactDOM.render(
  <React.StrictMode>
    <AuthProvider {...oidcConfig}>
      <App />
    </AuthProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
